/* eslint-disable prettier/prettier */

export const EMPTY_DISPLAY_VALUE = '-';

const SHORT_MONTHS = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec',
];

/**
 * Strips only the last extension from a file name for display.
 * "Report.final.pdf" -> "Report.final", ".env" -> ".env", "" / null -> "-"
 */
export const getFileNameWithoutExtension = (
	fileName?: string | null
): string => {
	const name = fileName?.trim();
	if (!name) return EMPTY_DISPLAY_VALUE;

	const lastDot = name.lastIndexOf('.');
	const baseName = lastDot > 0 ? name.slice(0, lastDot).trim() : name;

	return baseName || EMPTY_DISPLAY_VALUE;
};

/**
 * Formats a date for table display; missing / invalid dates -> "-".
 * Defaults to "10 Sep 2026".
 */
export const formatDisplayDate = (
	date?: string | Date | null,
	options: Intl.DateTimeFormatOptions = {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
	}
): string => {
	if (!date) return EMPTY_DISPLAY_VALUE;

	const parsed = new Date(date);
	if (Number.isNaN(parsed.getTime())) return EMPTY_DISPLAY_VALUE;

	// Some ICU versions render en-GB September as "Sept"; keep 3-letter months
	return new Intl.DateTimeFormat('en-GB', options)
		.formatToParts(parsed)
		.map(part =>
			part.type === 'month' && options.month === 'short'
				? SHORT_MONTHS[parsed.getMonth()]
				: part.value
		)
		.join('');
};
